import type { CropDefinition, PersistedGameState, PlayerState } from '../../../core/domain/types';

export const STARTER_RELIEF_SEEDS = 3;

export function inventoryCount(inventory: Record<string, number>): number {
  return Object.values(inventory).reduce((sum, amount) => sum + Math.max(0, amount), 0);
}

export function addInventory(
  inventory: Record<string, number>,
  itemId: string,
  quantity: number,
): Record<string, number> {
  return { ...inventory, [itemId]: Math.max(0, (inventory[itemId] ?? 0) + quantity) };
}

export function addXp(player: PlayerState, amount: number): PlayerState {
  let xp = player.xp + Math.max(0, amount);
  let level = player.level;
  while (level < 15 && xp >= level * 100) {
    xp -= level * 100;
    level += 1;
  }
  return { ...player, level, xp };
}

export function canAfford(player: PlayerState, price: number): boolean {
  return player.coins >= price;
}

export function canClaimStarterSeedRelief(
  game: PersistedGameState,
  cropDefinitions: CropDefinition[],
): boolean {
  const cheapestSeedPrice = Math.min(...cropDefinitions.map((crop) => crop.seedPrice));
  const hasSeeds = cropDefinitions.some((crop) => (game.inventory['seed_' + crop.id] ?? 0) > 0);
  const hasHarvest = cropDefinitions.some((crop) => (game.inventory[crop.id] ?? 0) > 0);
  const hasGrowingCrop = game.farm.plots.some((plot) => plot.cropId !== null);

  return game.player.coins < cheapestSeedPrice && !hasSeeds && !hasHarvest && !hasGrowingCrop;
}
